<template>
  <select class="kd-form__select selectpicker" v-bind:multiple="multiple" v-bind:title="title" v-bind:data-live-search="searchable">
    <option v-if="optionsCaption" v-bind:value="null">{{optionsCaption}}</option>
    <template v-if="hasOptGroups">
      <optgroup v-for="group in options" v-bind:label="group.name">
        <option v-for="option in group.options" v-bind:disabled="option.disabled" v-bind:value="optionsValue ? option[optionsValue] : option">{{optionsText ? option[optionsText] : option}}</option>
      </optgroup>
    </template>
    <template v-else-if="options.length">
      <option v-for="(option, index) in options" v-bind:disabled="option.disabled" v-bind:value="optionValue(option, index)">{{optionsText ? option[optionsText] : option}}</option>
    </template>
    <template v-else>
      <option disabled>{{i18nTranslations('dict.nothing_to_select')}}</option>
    </template>
  </select>
</template>

<script>
  export default {
    props: ['options', 'optionsValue', 'optionsText', 'optionsCaption', 'hasOptGroups', 'multiple', 'title', 'value', 'disabled', 'searchable'],
    watch: {
      value(value) {
        $(this.$el).val(value);
        this.refreshSelect();
      },
      options(options) {
        this.refreshSelect();
      },
      disabled(value) {
        $(this.$el).prop("disabled", value);
        this.refreshSelect();
      }
    },
    methods: {
      optionValue(option, index) {
        if (is.object(option)) {
          return this.optionsValue ? option[this.optionsValue] : index;
        }
        return option;
      },
      refreshSelect() {
        const $el = $(this.$el);
        this.$nextTick(function() {
          $el.selectpicker('refresh');
        });
      },
      i18nTranslations(text) {
        return I18n.t(text);
      }
    },
    mounted() {
      let vm = this;
      $(this.$el).val(this.value).selectpicker().on('change',function () {
        let primitive = $(this).selectpicker('val');
        // atm object value assignment only works for non opt-group based option collections
        if (is.object(vm.options[0]) && !vm.hasOptGroups && !vm.optionsValue) {
          let val =  _.find(vm.options, function(option, index) {
            return parseInt(primitive, 10) === index;
          });
          vm.$emit('input', val);
        } else {
          vm.$emit('input', $(this).selectpicker('val'));
        }
      });

      $(this.$el).prop("disabled", (this.disabled === true));
      this.refreshSelect();
    },
    destroyed() {
      this.$emit('input', null);
    }
  }
</script>
